import { Controller } from 'react-hook-form';
import { Dropdown, FormField } from '@which/seatbelt';
import styles from './ControlledDropdown.module.scss';
import { jsx as _jsx } from "react/jsx-runtime";
export const ControlledDropdown = _ref => {
  let {
    control,
    errorMsg,
    label,
    name,
    options,
    placeholderOption,
    required = false,
    tooltip,
    ...rest
  } = _ref;
  return /*#__PURE__*/_jsx(Controller, {
    control: control,
    name: name,
    render: _ref2 => {
      let {
        field: {
          onChange,
          value,
          ref
        },
        fieldState: {
          error
        }
      } = _ref2;
      return /*#__PURE__*/_jsx(FormField, {
        label: label,
        labelFor: name,
        required: required,
        ...(error && {
          errorMsg
        }),
        tooltip: tooltip,
        children: /*#__PURE__*/_jsx(Dropdown, {
          "aria-invalid": !!error,
          callback: onChange,
          id: name,
          name: name,
          options: options,
          placeholderOption: placeholderOption,
          selectRef: ref,
          value: value,
          variant: "regular",
          wrapperClassName: styles.formFieldDropdown,
          ...rest
        })
      });
    },
    rules: {
      required
    }
  });
};

///////// IMPLEMENTATION /////////